var Dispatcher = require('../dispatcher/appDispatcher'),
  ActionType = require('../constants/actionType'),
  SecurityApi = require('../api/securityApi');
var AppError = require('../utils/appError');
var utils = require('../utils');

var SecurityAction = {

  resetPassword(data){
    return SecurityApi.resetPassword(data)
      .then(this.filterBadRequest)
      .then(function () {
        Dispatcher.dispatch({
          actionType: ActionType.SECURITY_RESET_PASSWORD
        })
      })
      .catch(this.dispatchError);
  },

  validateResetPasswordToken(token){
    return SecurityApi.validateResetPasswordToken(token)
      .then(function (result) {
        if (result instanceof AppError) {
          Dispatcher.dispatch({
            actionType: ActionType.SECURITY_RESET_PASSWORD_TOKEN_VALIDATE,
            token: token,
            isValid: false
          });
        }
        else {
          Dispatcher.dispatch({
            actionType: ActionType.SECURITY_RESET_PASSWORD_TOKEN_VALIDATE,
            token: token,
            isValid: true
          });
        }
      })
      .catch(function () {
        Dispatcher.dispatch({
          actionType: ActionType.SECURITY_RESET_PASSWORD_TOKEN_VALIDATE,
          token: token,
          isValid: false
        })
      });
  },

  validateActivateAccountToken(token){
    return SecurityApi.validateActivateAccountToken(token)
      .then(function (result) {
        if (result instanceof AppError) {
          Dispatcher.dispatch({
            actionType: ActionType.SECURITY_ACTIVATE_ACCOUNT_TOKEN_VALIDATE,
            token: token,
            isValid: false
          });
        }
        else {
          Dispatcher.dispatch({
            actionType: ActionType.SECURITY_ACTIVATE_ACCOUNT_TOKEN_VALIDATE,
            token: token,
            isValid: true
          });
        }
      })
      .catch(function (error) {
        Dispatcher.dispatch({
          actionType: ActionType.SECURITY_ACTIVATE_ACCOUNT_TOKEN_VALIDATE,
          token: token,
          isValid: false
        })
      });
  },

  saveNewPassword(data, token){
    return SecurityApi.saveNewPassword(data, token)
      .then(this.filterBadRequest)
      .then(function () {
        Dispatcher.dispatch({
          actionType: ActionType.SECURITY_NEW_PASSWORD_SAVED
        })
      })
      .catch(this.dispatchError);
  },

  activateAccount(data, token){
    return SecurityApi.activateAccount(data, token)
      .then(this.filterBadRequest)
      .then(function () {
        Dispatcher.dispatch({
          actionType: ActionType.SECURITY_ACTIVATE_ACCOUNT
        })
      })
      .catch(this.dispatchError);
  },

  filterBadRequest(response){
    if (response instanceof utils.AppError) {
      throw response.errorObject;
    }
  },

  dispatchError(error){
    Dispatcher.dispatch({
      actionType: ActionType.SECURITY_ERROR,
      error: error
    });
  }

};

module.exports = SecurityAction;
